import React from 'react';
import { Col, Row } from 'antd';
import { Car } from '../../../types/carTypes';
import CarDetailsCard from "../../../components/car/CarDetailsCard";
import CarSpecsCard from "../../../components/car/CarSpecsCard";
import ErrorBoundary from "../../../components/ErrorBoundary";
import { cardsGridColumn } from "../../../assets/styles";
import CarAccessoriesCard from "../../../components/car/CarAccessoriesCard";
import { Skeleton } from "antd";

interface CarGeneralInfoProps {
    car?: Car;
    isStaff: boolean;
    isLoading: boolean
}

function CarGeneralInfo({ car, isStaff, isLoading }: CarGeneralInfoProps) {
    if (!car) {
        return <Skeleton active loading={isLoading} />;
    }

    return (
        <ErrorBoundary>
            <Row gutter={16}>
                <Col {...cardsGridColumn}>
                    <CarDetailsCard
                        car={car}
                        isStaff={isStaff}
                    />
                </Col>
                <Col {...cardsGridColumn}>
                    <CarSpecsCard
                        car={car}
                        isStaff={isStaff}
                    />
                </Col>
                <Col {...cardsGridColumn}>
                    <CarAccessoriesCard car={car} />
                </Col>
            </Row>
        </ErrorBoundary>
    );
}

export default CarGeneralInfo;